import {Link, RouteComponentProps} from '@reach/router';
import {Column} from 'material-table';
import React from 'react';
import {AdminElement} from '../../Components/auth/AdminElement';
import {CreateButton} from '../../Components/Buttons/CreateButton';
import Row from '../../Components/Layout/Row';
import {RowOfButtons} from '../../Components/Layout/RowOfButtons';
import PageTitle from '../../Components/PageTitle/PageTitle';
import {UniversalRListTable} from '../../Components/UniversalRListTable/UniversalRListTable';

/**
 * Event subject's read list.
 * @param {RouteComponentProps} props
 * @return {JSX.Element}
 * @constructor
 */
export default function EventSubjectsReadList(props: RouteComponentProps) {
  const apiUriPrefix = '/event-subject/';

  const Columns: Column<any>[] = [
    {
      title: '#',
      field: 'id',
      filtering: false,
    },
    {
      title: 'Название',
      field: 'name',
      render: (rowData): React.ReactNode =>
        <Link to={`${apiUriPrefix}${rowData.id}`}>{rowData.name}</Link>,
    },
  ];

  const lastQueryKeyName = 'eventSubjectsReadList';

  return (
    <React.Fragment>
      <PageTitle title={'Предметы мероприятий'}/>
      <RowOfButtons>
        <AdminElement>
          <CreateButton entity={'event-subject'}/>
        </AdminElement>
      </RowOfButtons>

      <Row>
        <UniversalRListTable
          columns={Columns}
          action={'EVENT_SUBJECTS_INDEX'}
          tableName={lastQueryKeyName}
        />
      </Row>
    </React.Fragment>
  );
}


